import { render } from "./ResidualWizard.vue?vue&type=template&id=d2c7fd8e&scoped=true&ts=true"
import script from "./ResidualWizard.ts?vue&type=script&lang=ts"
export * from "./ResidualWizard.ts?vue&type=script&lang=ts"

import "./ResidualWizard.scss?vue&type=style&index=0&id=d2c7fd8e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2c7fd8e"]])

export default __exports__